import _ from 'lodash';

export class FileHelper {
  static getFileFromFileList(files: FileList | null): File | null {
    return _.isEmpty(files) || _.isNil(files) ? null : files[0];
  }
}
